import fetchClient from '@eureca/recruiter-api-sdk/client';
import type { BulkDocumentType } from './program-export-availability';

/**
 * DEV-498 — pede ao BFF a exportação em massa de currículos/laudos do
 * programa. Diferente das bases, NADA baixa: o Core responde 202 e o resultado
 * chega por e-mail. O `code` do 422 (`program_has_no_resumes` /
 * `program_has_no_attestations`) vem em `error` — é o que decide o toast.
 */
export class BulkDocumentExportRequestError extends Error {
  readonly name = 'BulkDocumentExportRequestError';
  constructor(
    readonly status: number,
    readonly code: string | null
  ) {
    super(`Bulk document export request failed (status ${status}${code ? `, ${code}` : ''})`);
  }
}

export interface BulkDocumentExportAccepted {
  exportId: string;
  /** `false` = exportação já em curso; quem acionou entrou como destinatário (AC-13). */
  created: boolean;
}

export async function requestBulkDocumentExport(
  programId: string,
  type: BulkDocumentType
): Promise<BulkDocumentExportAccepted> {
  const res = await fetchClient<BulkDocumentExportAccepted, { error?: unknown }>({
    method: 'POST',
    url: `/programs/${programId}/bulk-document-exports`,
    data: { type },
  });
  if (res.error) {
    const body = res.error.error;
    const code =
      body && typeof body === 'object' && 'error' in body && typeof body.error === 'string'
        ? body.error
        : null;
    throw new BulkDocumentExportRequestError(res.error.status, code);
  }
  return res.data;
}
